import { useState, useReducer, Fragment, useEffect } from 'react';

import { connect, useSelector } from 'react-redux';

import AddProperty from './AddProperty';
import CopyModal from './CopyModal';
import ShortlistTable from './ShortlistTable';

import download from '../../assets/img/download.svg';
import leftArrow from '../../assets/img/leftArrow_shortlist.svg';
import pdfIcon from '../../assets/img/pdfIcon.svg';
import shareIcon from '../../assets/img/share.svg';
import tourIcon from '../../assets/img/tourIcon.svg';
import useQuery from '../../hooks/useQuery';
import * as actionTypes from '../../store/actions/index';
import { scrollClickHandler } from '../../utils/utils';
import PopupModal from '../PopupModal/PopupModal';
import RequestForTour from '../RequestForTour/RequsetForTour';
import TourSuccessful from '../RequestForTour/TourSuccessful';
import Spinner from '../Spinner/Spinner';

import './ShortlistComponent.css';

const initialState = {
  isDetailsTabSelected: true,
  isAmenitiesTabSlected: false,
  isCostTabSelected: false,
  isNotesTabIslected: false,
  isTourTabSelected: false,
  tabularContent: 'DETAILS',
};

const shortlisTabReducer = (state = { initialState }, action) => {
  switch (action.type) {
    case 'DETAILS':
      return initialState;
    case 'AMENITIES':
      return {
        ...state,
        isDetailsTabSelected: false,
        isAmenitiesTabSlected: true,
        isCostTabSelected: false,
        isNotesTabIslected: false,
        isTourTabSelected: false,
        tabularContent: action.type,
      };
    case 'COST':
      return {
        ...state,
        isDetailsTabSelected: false,
        isAmenitiesTabSlected: false,
        isCostTabSelected: true,
        isNotesTabIslected: false,
        isTourTabSelected: false,
        tabularContent: action.type,
      };
    case 'NOTES':
      return {
        ...state,
        isDetailsTabSelected: false,
        isAmenitiesTabSlected: false,
        isCostTabSelected: false,
        isNotesTabIslected: true,
        isTourTabSelected: false,
        tabularContent: action.type,
      };
    case 'TOUR':
      return {
        ...state,
        isDetailsTabSelected: false,
        isAmenitiesTabSlected: false,
        isCostTabSelected: false,
        isNotesTabIslected: false,
        isTourTabSelected: true,
        tabularContent: action.type,
      };
    default:
      return state;
  }
};
const ShortlistComponent = (props) => {
  const [state, dispatch] = useReducer(shortlisTabReducer, initialState);
  const [showModal, setShowModal] = useState(false);
  const [showCopy, setShowCopy] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showTour, setShowTour] = useState(false);

  const query = useQuery();
  const shortlist = useSelector((state) => state.shortlistRed.shortlistedOptions);

  const options = useSelector((state) => state.optRed.data.options);
  const { isTourRequestSuccessful, showLoading } = useSelector((state) => state.optRed);
  const isTourDisabled = !(
    shortlist.length -
    options?.filter((option) => option.shortListed && option.tourRequestedDate?.length).length
  );

  const isShortlistedSearch = query.get('isShortlisted');

  const { surveyData, currentDeal } = props;

  const onDetails = () => {
    dispatch({ type: 'DETAILS' });
  };

  const onAmenities = () => {
    dispatch({ type: 'AMENITIES' });
  };

  const onCost = () => {
    dispatch({ type: 'COST' });
  };

  const onNotes = () => {
    dispatch({ type: 'NOTES' });
  };

  const onTour = () => {
    dispatch({ type: 'TOUR' });
  };

  const closeTour = () => {
    setShowTour(!showTour);
    if (isTourRequestSuccessful) {
      props.tourRequestViewCounter();
      props.setIsRequestTourSuccessful();
    }
  };

  useEffect(() => {
    if (isTourRequestSuccessful) {
      setShowTour((prev) => !prev);
    }
  }, [isTourRequestSuccessful, setShowTour]);

  useEffect(() => {
    if (isTourRequestSuccessful) {
      const timer = setTimeout(() => {
        // Select the close button using querySelector and trigger the click event
        document.querySelector('.modal-close') && document.querySelector('.modal-close').click();
      }, 5000);

      // Clear the timer when the component is unmounted or when the modal is closed
      return () => clearTimeout(timer);
    }
  }, [isTourRequestSuccessful]);

  return (
    <div id="shortlist">
      <header className="shortlistHeader">
        <div className="leftHeader">
          <span>
            <img
              src={leftArrow}
              style={{ width: '20px', height: '20px', padding: '2px' }}
              alt="leftArrow"
              onClick={() => scrollClickHandler('optionDetail_top')}
            />
          </span>
          <span className="text">Shortlist ({shortlist.length})</span>
        </div>
        <div className="actionsDiv">
          {!isShortlistedSearch && (
            <Fragment>
              {/* Download PDF Button */}
              <button
                className={'btn'}
                onClick={props.pdfDownloadClick}
                disabled={shortlist.length === 0}
              >
                <span>
                  <img src={pdfIcon} alt="Download PDF" />
                </span>
                <span>Download PDF</span>
              </button>

              {/* Share Shortlist Button */}
              <button
                className={'btn'}
                disabled={shortlist.length === 0}
                onClick={() => {
                  const url = window.location.pathname;
                  const prefix = window.location.origin;

                  navigator.clipboard.writeText(`${prefix}${url}?isShortlisted=true`);
                  props.shortlistViewCounter();
                  setShowCopy(true);
                }}
              >
                <span>
                  <img src={shareIcon} alt="share" />
                </span>
                <span style={{ marginLeft: '10px' }}>Share Shortlist</span>
              </button>

              {/* Add Property Button */}
              <button className="btn" onClick={() => setShowModal(true)}>
                <span style={{ fontSize: '28px' }}>+</span>
                <span> Add Property</span>
              </button>

              {/* Request For Tour Button */}
              <button
                className={'btn'}
                disabled={isTourDisabled}
                onClick={closeTour}
                title="Option disabled as all shortlisted 
                properties are selected for tour"
              >
                <span>
                  <img src={tourIcon} alt="Request Tour" width="20" height="20" />
                </span>
                <span> Request Tour</span>
              </button>
              {showLoading && <Spinner></Spinner>}
              {showTour && (
                <PopupModal open={showTour} onClose={closeTour}>
                  {!isTourRequestSuccessful ? (
                    <RequestForTour onCancel={closeTour} />
                  ) : (
                    <TourSuccessful />
                  )}
                </PopupModal>
              )}
            </Fragment>
          )}
        </div>
      </header>

      <nav className="shortlist__tabs">
        <ul>
          <li id="1" onClick={onDetails} className={state.isDetailsTabSelected ? 'active' : ''}>
            Provider Details
          </li>
          <li id="2" onClick={onCost} className={state.isCostTabSelected ? 'active' : ''}>
            Cost
          </li>
          <li id="3" onClick={onAmenities} className={state.isAmenitiesTabSlected ? 'active' : ''}>
            Amenities
          </li>
          <li id="4" onClick={onNotes} className={state.isNotesTabIslected ? 'active' : ''}>
            Notes
          </li>
          <li id="4" onClick={onTour} className={state.isTourTabSelected ? 'active' : ''}>
            Tour Info
          </li>
        </ul>
      </nav>
      <div className="shortListTable">
        <ShortlistTable
          content={state.tabularContent}
          surveyData={surveyData}
          currentDeal={currentDeal}
        />
      </div>

      {showModal && <AddProperty hideModal={() => setShowModal(false)} />}
      {showCopy && <CopyModal hideModal={() => setShowCopy(false)} />}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    surveyData: state.optRed.data.survey,
    currentDeal: state.comRed.currentDeal,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    shortlistViewCounter: () => dispatch(actionTypes.updateCounter(0, 'shortlistViewCounter')),
    tourRequestViewCounter: () => dispatch(actionTypes.updateCounter(0, 'tourCounter')),
    setIsRequestTourSuccessful: () =>
      dispatch({ type: 'SET_TOUR_REQUEST', isTourRequestSuccessful: false }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShortlistComponent);
// export default ShortlistComponent;
